<template>
  <a-modal
    :visible="true"
    title="设置描述"
    okText="保存"
    cancelText="取消"
    @cancel="$emit('cancel')"
    @ok="$emit('edit', value)"
  >
    <a-textarea placeholder="输入描述" allow-clear v-model="value" />
  </a-modal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      value: ""
    };
  },
  methods: {},
  computed: {
    ...mapGetters(["categorys"])
  }
};
</script>
